import React, { useEffect, useRef, useState } from "react";
import "ol/ol.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import '../App.css';
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import { TileWMS, XYZ } from "ol/source";
import OSM from "ol/source/OSM";
import { fromLonLat } from "ol/proj";
import LayerSwitcher from "ol-layerswitcher";
import { ScaleLine, FullScreen, defaults as defaultControls, Control } from "ol/control";
import * as d3 from "d3";
import { RegularShape, Stroke } from "ol/style";

import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import CircleStyle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import proj4 from 'proj4';
import Graph from "./graph";
import api from "../services/api";

// Function to get color based on LWE_Thickness value
const getColor = (value, min, max) => {
  const normalizedValue = (value - min) / (max - min);
  const hue = normalizedValue * 240; // Red to Blue
  return `hsl(${hue}, 100%, 50%)`;
};

// Custom Legend Control
class LegendControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("div");
    element.className = "legend ol-unselectable ol-control";
    element.style.backgroundColor = "black";
    element.style.padding = "10px";
    element.style.borderRadius = "5px";
    element.style.boxShadow = "0 2px 4px rgba(0,0,0,0.3)";

    super({ element: element, target: options.target });

    this.minValue = 0;
    this.maxValue = 0;
  }

  setMap(map) {
    super.setMap(map);
    if (map) this.render();
  }

  updateLegend(minValue, maxValue) {
    this.minValue = maxValue;
    this.maxValue = minValue;
    this.render();
  }

  render() {
    const midValue = (this.minValue + this.maxValue) / 2;
    const gradient = `linear-gradient(to bottom, 
      ${getColor(this.minValue, this.minValue, this.maxValue)}, 
      ${getColor(midValue, this.minValue, this.maxValue)}, 
      ${getColor(this.maxValue, this.minValue, this.maxValue)})`;

    this.element.innerHTML = `
      <div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">Lwe_thickness</div>
      <div style="display: flex; align-items: center;">
        <div style="width: 20px; height: 150px; background: ${gradient}; margin-right: 10px;"></div>
        <div style="display: flex; flex-direction: column; justify-content: space-between; height: 150px;">
           <span>${this.maxValue.toFixed(2)}</span>
          <span>${((this.maxValue + this.minValue) / 2).toFixed(2)}</span>
          <span>${this.minValue.toFixed(2)}</span>
        </div>
      </div>`;
  }
}

function Basin_selection() {
  const mapRef = useRef(null);
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [basin, setBasin] = useState("");
  const [map, setMap] = useState(null);
  const [vectorLayer, setVectorLayer] = useState(null);
  const [popupContent, setPopupContent] = useState("");
  const [popupStyle, setPopupStyle] = useState({ left: '0px', top: '0px' });
  const sourceProj = 'EPSG:3857'; // Example source projection (Web Mercator)
  const destProj = 'EPSG:4326'; 
  const [loading, setLoading] = useState(false);
  
  // const handleSubmit = () => {
  //   if (startYear && endYear && map) {
  //     fetch(`http://192.168.1.6:8000/basin1/?basin=${basin}&start=${startYear}&end=${endYear}`)
  //       .then(response => {
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! status: ${response.status}`);
  //         }
  //         return response.json();
  //       })
  //       .then(data => {
  //         const vectorSource = new VectorSource({
  //           features: new GeoJSON().readFeatures(data, {
  //             featureProjection: 'EPSG:3857'
  //           })
  //         });

  //         const newVectorLayer = new VectorLayer({
  //           source: vectorSource,
  //           style: function (feature) {
  //             const value = feature.get("LWE_Thickness");
  //             return new Style({
  //               image: new CircleStyle({
  //                 radius: 10,
  //                 fill: new Fill({
  //                   color: getColor(value),
  //                 }),
  //               }),
  //             });
  //           },
  //           title: "GeoJSON Layer",
  //         });

  //         if (vectorLayer) {
  //           map.removeLayer(vectorLayer);
  //         }

  //         map.addLayer(newVectorLayer);
  //         setVectorLayer(newVectorLayer);
  //       })
  //       .catch(error => console.error('Error fetching GeoJSON data:', error));
  //   }
  // };


  const handleSubmit = () => {
    if (startYear && endYear && map) {
      setLoading(true);
  
      api.get("/basin1/", { params: { basin, start: startYear, end: endYear } })
      .then((response) => {
        const data = response.data;
        const features = new GeoJSON().readFeatures(data, { featureProjection: "EPSG:3857" });
        
        const lweValues = features.map((feature) => feature.get("LWE_Thickness"));
        const minLWE = Math.min(...lweValues);
        const maxLWE = Math.max(...lweValues);
        
        const vectorSource = new VectorSource({ features });
          if (vectorLayer) {
            map.removeLayer(vectorLayer);
          }
  
          const newVectorLayer = new VectorLayer({
            source: vectorSource,
            style: (feature) => {
              const value = feature.get("LWE_Thickness");
              return new Style({
                image: new RegularShape({
                  points: 4,
                  radius: 60,
                 
                  fill: new Fill({ color: getColor(feature.get("LWE_Thickness"), minLWE, maxLWE) }),
                  stroke: new Stroke({ color: getColor(feature.get("LWE_Thickness"), minLWE, maxLWE) }),

                 
                }),
                zIndex: 1, // Lower zIndex for GeoJSON layer

              });
            },
            title: "GeoJSON Layer",
          });
  
          map.addLayer(newVectorLayer);
          setVectorLayer(newVectorLayer);
  
          // **Zoom to the features**
          const extent = vectorSource.getExtent();
          if (extent) {
            map.getView().fit(extent, { padding: [40, 40, 40, 40], duration: 1000 });
            
            
          }
  
          // Add popup functionality
           map.on("singleclick", (evt) => {
                   const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => feature);
                   if (feature) {
                     const flatCoordinates = [feature.values_.geometry.flatCoordinates[0], feature.values_.geometry.flatCoordinates[1]];
                     const [lon, lat] = proj4(sourceProj, destProj, flatCoordinates);
         
                     const properties = feature.getProperties();
                     const content = '<u>'+'<b>'+'Ethiopia Basin Lwe_thickness'+'</b>'+'<br/>'+'</u>'+
                     `Latitude: <span style="background-color:#848484;color:white">${lat.toFixed(3)}</span><br/>
                       Longitude: <span style="background-color:#848484;color:white">${lon.toFixed(3)}</span><br/>
                       LWE_Thickness: <span style="background-color:${getColor(properties.LWE_Thickness.toFixed(3), minLWE, maxLWE)};color:white">${properties.LWE_Thickness.toFixed(3)}</span>`;
                     setPopupContent(content);
         
                     const coordinate = evt.coordinate;
                     const pixel = map.getPixelFromCoordinate(coordinate);
                     setPopupStyle({
                       left: `${pixel[0]}px`,
                       top: `${pixel[1]}px`,
                     });
         
                     const popupElement = document.getElementById("popup");
                     popupElement.classList.add("active");
                   }
                 });
         
  
          // Hide the popup when clicking elsewhere
          map.on("click", () => {
            const popupElement = document.getElementById("popup");
            popupElement.classList.remove("active");
          });
  
          // Update legend
          const legendControl = map.getControls().getArray().find((control) => control instanceof LegendControl);
          if (legendControl) legendControl.updateLegend(minLWE, maxLWE);
        })
        .catch(error => console.error('Error fetching GeoJSON data:', error))
        .finally(() => setLoading(false));
    }
  };
  



  useEffect(() => {
    if (!mapRef.current) return;

    const initialMap = new Map({
      controls: defaultControls().extend([new FullScreen(), new LegendControl()]),
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
          title: "OSM",
          visible: false,
        }),
        new TileLayer({
          source: new XYZ({
            url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
          }),
          title: "Satellite",
          visible: true,
        }),
        new TileLayer({
          source: new TileWMS({
            url: "http://196.188.116.41:8082/geoserver/geoserver/wms",
            params: { LAYERS: "geoserver:Ethiopia_Basins", TILED: true },
            serverType: "geoserver",
            visible: false,
            transition: 0,
          }),
          title: "Ethiopia",
          visible: true,
          opacity: 0.8,
          zIndex: 2, // Higher zIndex to ensure it's on top of the GeoJSON layer
        }),
      ],
      view: new View({
        center: fromLonLat([38.971861469308, 8.748207216169536]),
       
         zoom: 6.5,
        minZoom: 5.5,
        maxZoom: 8,
      }),
    });

    const layerSwitcher = new LayerSwitcher({
      reverse: true,
      activationMode: "click",
      groupSelectStyle: "children",
    });
    initialMap.addControl(layerSwitcher);

    const scaleLineMetric = new ScaleLine({
      units: "metric",
      target: document.getElementById("scaleline-metric"),
    });
    initialMap.addControl(scaleLineMetric);

    setMap(initialMap);

    return () => initialMap.dispose();
  }, []);

  const close = () => {
    const popupElement = document.getElementById("popup");
    if (popupElement) {
      popupElement.classList.remove("active");
    }
    return false;
  };

  return (
    <>
      <div className="annualSelection_basin">
        <label>Basin</label>
        <select id="basin" onChange={(e) => setBasin(e.target.value)}>
          <option value="Awash">Awash</option>
          <option value="Abay">Abay</option>
          <option value="Genalle">Genalle</option>
          <option value="Angereb">Angereb</option>
          <option value="Atbara">Atbara</option>
          <option value="Bilate">Bilate</option>
          <option value="Danakil">Danakil</option>
          <option value="Golina">Golina</option>
          <option value="Mereb11">Mereb</option>
          <option value="Red Sea Coast">Red Sea Coast</option>
          <option value="Shebelle">Shebelle</option>
          <option value="Tekeze">Tekeze</option>
          <option value="Ziway/Abijata">Ziway/Abijata</option>
          <option value="Segen">Segen</option>
          <option value="Omo">Omo</option>
          <option value="Baro">Baro</option>

        </select>
        <label className="start_year">Start Year:</label>
        <input
          type="number"
          id="startYear"
          placeholder="Start Year"
          onChange={(e) => setStartYear(e.target.value)}
          min="2002"
          max="2024"
          step="1"
        />
        <label className="end_year">End Year:</label>
        <input
          type="number"
          id="endYear"
          placeholder="End Year"
          onChange={(e) => setEndYear(e.target.value)}
          min="2002"
          max="2024"
          step="1"
        />
        <button
          type="submit"
          className="form-bcontrol end_year"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Loading..." : "Submit"}
        </button>

        <br />
        <br />
        <div className="date_calculate">
          {basin + ' Basin'} <span>{startYear}</span> - <span>{endYear}</span>
        </div>
      </div>



      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Loading data...</p>
        </div>
      )}
      <div className="main-container">
      <div id="popup" className="ol-popup" >
        <a href="#" id="popup-closer" className="ol-popup-closer" onClick={close}></a>
        <div id="popup-content" dangerouslySetInnerHTML={{ __html: popupContent }}></div>
      </div>
      <div id="map" className="map" ref={mapRef} style={{ width: "100%", height: "100vh" }}></div>
           </div>
    </>
  );
}

export default Basin_selection;
